import type { SVGProps } from 'react';
import { forwardRef, Ref } from 'react';

const SvgSchotelantenne = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 40 40"
    role="img"
    aria-hidden={true}
    ref={ref}
    {...props}
  >
    <path
      fill="#85BDED"
      d="M23.24 22.8a2.8 2.8 0 1 0 0-5.6 2.8 2.8 0 0 0 0 5.6"
    />
    <path
      fill="#00215B"
      fillRule="evenodd"
      d="M30.651 13.362a7.9 7.9 0 0 0-3.399-1.786l.236-.972a8.88 8.88 0 0 1 5.054 13.903l-.804-.594a7.88 7.88 0 0 0-1.087-10.551"
      clipRule="evenodd"
    />
    <path
      fill="#00215B"
      fillRule="evenodd"
      d="M26.817 13.324a6.09 6.09 0 0 1 3.476 9.533l-.806-.594a5.09 5.09 0 0 0-2.904-7.967z"
      clipRule="evenodd"
    />
    <path
      fill="#00215B"
      fillRule="evenodd"
      d="M28.78 15.448a5.1 5.1 0 0 0-2.197-1.152l.234-.972a6.09 6.09 0 0 1 3.476 9.533l-.806-.594a5.09 5.09 0 0 0-.707-6.815"
      clipRule="evenodd"
    />
    <path
      fill="#00215B"
      fillRule="evenodd"
      d="M26.111 16.043a3.29 3.29 0 0 1 1.922 5.153l-.806-.592a2.29 2.29 0 0 0-1.338-3.587z"
      clipRule="evenodd"
    />
    <path
      fill="#0061CD"
      d="M6.39 22.81v2.8h5.59v-2.8z"
    />
    <path
      fill="#0061CD"
      d="m11.003 22.994.957 2.631 6.371-2.318-.957-2.632z"
    />
    <path
      fill="#0061CD"
      fillRule="evenodd"
      d="M28.05 33.14a15.25 15.25 0 0 1-9.56-26.28z"
      clipRule="evenodd"
    />
    <path
      fill="#85BDED"
      d="M9.18 18h-2.8v12h2.8z"
    />
  </svg>
);

/* eslint-disable import/no-default-export */
const ForwardRef = forwardRef(SvgSchotelantenne);

export default ForwardRef;
